import { useQuery } from '@tanstack/react-query';
import { getAccessibleSites } from '../api/filesApi';

export const accessibleSitesKeys = {
  all: ['accessible-sites'] as const,
};

export function useAccessibleSites() {
  return useQuery({
    queryKey: accessibleSitesKeys.all,
    queryFn: () => getAccessibleSites(),
  });
}
